import Marionette from "backbone.marionette";

import GoodsTpl from "views/goodsPDF/goodsPDFView.ejs";
//Secondary
import AcuerdosTpl from "views/goodsDetail/sections/acuerdos.ejs";
import CatastralesTpl from "views/goodsDetail/sections/catastrales.ejs";
import MejorasTpl from "views/goodsDetail/sections/mejoras.ejs";
import RegistralesTpl from "views/goodsDetail/sections/registrales.ejs";
import TitulosTpl from "views/goodsDetail/sections/titulos.ejs";
import DocumentTpl from "views/goodsDetail/sections/documentos.ejs";

import ParametersModel from "models/parametersModel.js";
var parametersModel = new ParametersModel();

import Amortizacion from "models/amortizacion.js";

import GoodModel from "models/goodModel.js";

import S from "session/session.js";
import T from "session/token.js";

//Definition of group fields according to epigraphs

/*
var related = {
    0: ["EPIGRAPH_1", "EPIGRAPH_2", "EPIGRAPH_5", "EPIGRAPH_39", "EPIGRAPH_40"],
    1: ["EPIGRAPH_3"],
    2: ["EPIGRAPH_4", "EPIGRAPH_13", "EPIGRAPH_46"],
    3: ["EPIGRAPH_6", "EPIGRAPH_8"],
    4: ["EPIGRAPH_7", "EPIGRAPH_9"],
    5: ["EPIGRAPH_10", "EPIGRAPH_11"],
    6: ["EPIGRAPH_12"],
    7: ["EPIGRAPH_14"],
    8: ["EPIGRAPH_15", "EPIGRAPH_16"],
    9: ["EPIGRAPH_17", "EPIGRAPH_18", "EPIGRAPH_19", "EPIGRAPH_20", "EPIGRAPH_21", "EPIGRAPH_22", "EPIGRAPH_23", "EPIGRAPH_24", "EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27",
        "EPIGRAPH_28", "EPIGRAPH_29", "EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37",
        "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41"
    ],
    10: ["EPIGRAPH_32"],
    11: ["EPIGRAPH_42", "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_45"]
};

*/



//Definition of group fields according to epigraphs
var related = {


    0: ["EPIGRAPH_1", "EPIGRAPH_2", "EPIGRAPH_3", "EPIGRAPH_4", "EPIGRAPH_5", "EPIGRAPH_6", "EPIGRAPH_7", "EPIGRAPH_83", "EPIGRAPH_84", "EPIGRAPH_88", "EPIGRAPH_94"],
    1: ["EPIGRAPH_8"],

    3: ["EPIGRAPH_13", "EPIGRAPH_14", "EPIGRAPH_15", "EPIGRAPH_16", "EPIGRAPH_17", "EPIGRAPH_23", "EPIGRAPH_24"],

    5: ["EPIGRAPH_18", "EPIGRAPH_19"],
    6: ["EPIGRAPH_21"],

    8: ["EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28"],

    9: ["EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_32", "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_45",
        "EPIGRAPH_46", "EPIGRAPH_47", "EPIGRAPH_48", "EPIGRAPH_49", "EPIGRAPH_50", "EPIGRAPH_51", "EPIGRAPH_52", "EPIGRAPH_53",
        "EPIGRAPH_54", "EPIGRAPH_55", "EPIGRAPH_56", "EPIGRAPH_57", "EPIGRAPH_58", "EPIGRAPH_59", "EPIGRAPH_60", "EPIGRAPH_61",
        "EPIGRAPH_62", "EPIGRAPH_63", "EPIGRAPH_65", "EPIGRAPH_66", "EPIGRAPH_67", "EPIGRAPH_68", "EPIGRAPH_69", "EPIGRAPH_71",
        "EPIGRAPH_72", "EPIGRAPH_73", "EPIGRAPH_74", "EPIGRAPH_75", "EPIGRAPH_76", "EPIGRAPH_77", "EPIGRAPH_78", "EPIGRAPH_79",
        "EPIGRAPH_80", "EPIGRAPH_81", "EPIGRAPH_90", "EPIGRAPH_93"
    ],

    11: ["EPIGRAPH_11"],
    12: ["EPIGRAPH_10", "EPIGRAPH_89", "EPIGRAPH_95"],
    13: ["EPIGRAPH_9"],
    14: ["EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41", "EPIGRAPH_42",
        "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_64", "EPIGRAPH_70"
    ],
    15: ["EPIGRAPH_82"],
    16: ["EPIGRAPH_20", "EPIGRAPH_22"],
    17: ["EPIGRAPH_87"],
    18: ["EPIGRAPH_29"],
    19: ["EPIGRAPH_12"],
    20: ["EPIGRAPH_91", "EPIGRAPH_92"],
    21: ["EPIGRAPH_85", "EPIGRAPH_86"],
    22: ["EPIGRAPH_96", "EPIGRAPH_97"],
};




var hideCatastralesEpigraphs = [
    "EPIGRAPH_8",
    //// "EPIGRAPH_5",
    "EPIGRAPH_13", "EPIGRAPH_14", "EPIGRAPH_15", "EPIGRAPH_16", "EPIGRAPH_17", "EPIGRAPH_20", "EPIGRAPH_22", "EPIGRAPH_23", "EPIGRAPH_24",
    ////"EPIGRAPH_14",
    "EPIGRAPH_18", "EPIGRAPH_19",
    "EPIGRAPH_21",
    "EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28",
    "EPIGRAPH_12", "EPIGRAPH_29", "EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_32", "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_45",
    "EPIGRAPH_46", "EPIGRAPH_47", "EPIGRAPH_48", "EPIGRAPH_49", "EPIGRAPH_50", "EPIGRAPH_51", "EPIGRAPH_52", "EPIGRAPH_53",
    "EPIGRAPH_54", "EPIGRAPH_55", "EPIGRAPH_56", "EPIGRAPH_57", "EPIGRAPH_58", "EPIGRAPH_59", "EPIGRAPH_60", "EPIGRAPH_61",
    "EPIGRAPH_62", "EPIGRAPH_63", "EPIGRAPH_65", "EPIGRAPH_66", "EPIGRAPH_67", "EPIGRAPH_68", "EPIGRAPH_69", "EPIGRAPH_71",
    "EPIGRAPH_72", "EPIGRAPH_73", "EPIGRAPH_74", "EPIGRAPH_75", "EPIGRAPH_76", "EPIGRAPH_77", "EPIGRAPH_78", "EPIGRAPH_79",
    "EPIGRAPH_80", "EPIGRAPH_81",
    "EPIGRAPH_81",
    "EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41", "EPIGRAPH_42",
    "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_64", "EPIGRAPH_70", "EPIGRAPH_96", "EPIGRAPH_97"
];




var SectionView = Marionette.View.extend({
    initialize: function(data) {
        this.template = data.template;
    },
    render: function() {
        this.$el.html(this.template);
    }
});

export default Marionette.LayoutView.extend({
    initialize: function(data) {


        if (data.id) {
            this.id = data.id;
            this.model = new GoodModel({
                id: data.id
            });
        } else {
            this.model = new GoodModel();
            this.model.set({
                "epigraph": "EPIGRAPH_1"
            });
        }

        this.lang = data.lang;

        this.isEditablegooPdf = data.isEditableGood;

        this.listenTo(S.mApp, "templatesLoaded", this.applyTemplates.bind(this));
    },
    formData: {},
    template: GoodsTpl,
    render: function() {
        parametersModel.fetch({
            data: {
                instanceId: S.instanceId
            },
            beforeSend: T.useToken,
            success: function() {
                if (this.id) {
                    this.model.fetch({
                        data: {
                            instanceId: S.instanceId
                        },
                        beforeSend: T.useToken,
                        success: this.applyView.bind(this)
                    });
                } else {
                    this.applyView();
                }
            }.bind(this)
        });
    },
    map: null,
    applyView: function() {
        this.$el.html(this.template({
            attributes: this.model.attributes,
            lang: this.lang,
            parameters: parametersModel.toJSON(),
            viewable: this.isEditablegooPdf,
        }));

        this.loadTemplates(this.model.get("epigraph"));
    },
    hideCatastrales: function(epigraph) {

        if (hideCatastralesEpigraphs.indexOf(epigraph) >= 0) {
            return true;
        } else {
            return false;
        }

    },
    loadTemplates: function(epigraph) {
        var group;
        for (var r in related) {
            for (var e in related[r]) {
                if (epigraph === related[r][e])
                    group = r;
            }
        }

        var files = ["acuerdos", "incidencias", "catastrales", "descriptivos", "documentos", "economicos", "gps", "juridicos", "mejoras", "registrales", "seguros", "titulos", "urbanisticos"];
        var templates = [];
        var j = files.length - 1;

        // Load templates recursively
        function loadTemplate() {
            if (j === -1) {
                S.mApp.trigger("templatesLoaded", templates);
                return;
            } else {
                $.ajax({
                    url: "sections/" + group + "/" + files[j] + ".ejs",
                    success: function(template) {
                        var form = document.createElement("div");
                        form.innerHTML = template;
                        templates[form.firstChild.getAttribute("id")] = _.template(template);

                        $('.tab-content .money').mask("#.##0,00", { reverse: true });
                        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
                        $('.tab-content .integer').mask("#.##0", { reverse: true });
                        $('.tab-content .number').mask("##0", { reverse: true });



                    }
                }).always(function() {
                    loadTemplate();
                    j--;
                });
            }
        }

        loadTemplate();
    },
    applyTemplates: function(templates) {

        ////Se carga esta vista, para generar el PDF. 
        /*
        Por lo que se ve lo que hace se utiliza como plantilla para cargar los datos. Una vez que se cargan los datos, -> se ejecuta 
        end:pdf con todas las sections cargadas. Luego le devuelve el control a mainView.js. 
        
        */
        //Individual section
        this.descriptivos.show(new SectionView({
            template: templates.descriptivos({
                attributes: this.model.attributes || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.incidencias.show(new SectionView({
            template: templates.incidencias({
                attributes: this.model.attributes.incidencias || {},
                //parameters: parametersModel.toJSON(),
                lang: this.lang
            })
        }));

        /*this.ampliada.show(new SectionView({
            template: templates.ampliada({
                attributes: this.model.attributes.ampliada || {},
                parameters: parametersModel.toJSON(),
                lang: this.lang
            })
        }));*/

        this.mejoras.show(new SectionView({
            template: templates.mejoras({
                attributes: this.model.attributes.mejoras || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        var disableVidautl = "disabled";
        var disableOnlySuperAdmin = "disabled";
        this.economicos.show(new SectionView({
            template: templates.economicos({
                attributes: this.model.attributes || {},
                lang: this.lang,
                disableVa: disableVidautl,
                parameters: parametersModel.toJSON(),
                disableSoloAdmin: disableOnlySuperAdmin
            })
        }));

        this.gps.show(new SectionView({
            template: templates.gps({
                attributes: this.model.attributes.gps || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.juridicos.show(new SectionView({
            template: templates.juridicos({
                attributes: this.model.attributes || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));


        this.seguros.show(new SectionView({
            template: templates.seguros({
                attributes: this.model.attributes.seguros || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.urbanisticos.show(new SectionView({
            template: templates.urbanisticos({
                attributes: this.model.attributes.urbanisticos || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.registrales.show(new SectionView({
            template: templates.registrales({
                attributes: this.model.attributes.registrales || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.catastrales.show(new SectionView({
            template: templates.catastrales({
                attributes: this.model.attributes.catastrales || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.acuerdos.show(new SectionView({
            template: templates.acuerdos({
                attributes: this.model.attributes.acuerdos || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.titulos.show(new SectionView({
            template: templates.titulos({
                attributes: this.model.attributes.titulos || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        this.documentos.show(new SectionView({
            template: templates.documentos({
                attributes: this.model.attributes.documentos || {},
                lang: this.lang,

                parameters: parametersModel.toJSON()
            })
        }));

        //hide empty forms
        for (var i = 0; i < document.forms.length; i++) {
            var id = document.forms[i].getAttribute("id");
            if (!document.forms[i].elements.length) {
                $("#" + id + "-tab").hide();
                $("#" + id + "-list").addClass("hidden");
                $(".tab-pane#" + id).addClass("hidden");
            } else {
                $("#" + id + "-tab").show();
                $("#" + id + "-list").removeClass("hidden");
                $(".tab-pane#" + id).removeClass("hidden");
            }
        }

        /// MASTERS (1-n)
        //////////////////////////////////////////
        ///

        $('#mejorasList tbody').empty();
        if (document.querySelector("form#mejoras").elements.length) {
            var mejoras = this.model.attributes.mejoras;


            for (var m in mejoras) {


                var textDisabled = 'disabled';
                if (S.userInfo.get("role") == 0) {
                    textDisabled = '';
                }


                var tr = document.createElement('tr');
                tr.innerHTML = MejorasTpl({
                    attributes: mejoras[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang,
                    disabledcheck: textDisabled,
                    epi: this.model.attributes.epigraph,
                    isnuevamejora: -1
                });
                ///document.getElementById("mejorasList").appendChild(tr);
                tr.className = "valueList mejorasItem";
                var table = document.getElementById("mejorasList").getElementsByTagName('tbody')[0];
                table.appendChild(tr);


            }
        }
        ////comentado 27-11-2017
        ///// this.calculateAmortizacion();



        ///empty data acuerdos. 
        $('#acuerdosList tbody').empty();
        if (document.querySelector("form#acuerdos").elements.length) {
            var acuerdos = this.model.attributes.acuerdos;
            for (var m in acuerdos) {
                var tr = document.createElement('tr');
                tr.innerHTML = AcuerdosTpl({
                    attributes: acuerdos[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                //// document.getElementById("acuerdosList").appendChild(tr);
                tr.className = "valueList";
                var table = document.getElementById("acuerdosList").getElementsByTagName('tbody')[0];
                table.appendChild(tr);


            }
        }


        $('#catastralesList tbody').empty();



        if (this.hideCatastrales(this.model.attributes.epigraph)) {
            // Not showing catastrales
            $("#catastrales").addClass("hidden");
            $("#catastrales-list").addClass("hidden");
            $("#catastrales-tab").addClass("hidden");
        } else {

            if (document.querySelector("form#catastrales").elements.length) {
                var catastrales = this.model.attributes.catastrales;
                for (var m in catastrales) {
                    var tr = document.createElement('tr');
                    tr.innerHTML = CatastralesTpl({
                        attributes: catastrales[m],
                        parameters: parametersModel.toJSON(),
                        lang: this.lang
                    });
                    //// document.getElementById("catastralesList").appendChild(tr);
                    tr.className = "valueList";
                    var table = document.getElementById("catastralesList").getElementsByTagName('tbody')[0];
                    table.appendChild(tr);

                }
            }
        }


        $('#registralesList tbody').empty();
        if (document.querySelector("form#registrales").elements.length) {
            var registrales = this.model.attributes.registrales;
            for (var m in registrales) {
                var tr = document.createElement('tr');
                tr.innerHTML = RegistralesTpl({
                    attributes: registrales[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                ///document.getElementById("registralesList").appendChild(tr);
                tr.className = "valueList";
                var table = document.getElementById("registralesList").getElementsByTagName('tbody')[0];
                table.appendChild(tr);

            }
        }


        $('#titulosList tbody').empty();

        if (document.querySelector("form#titulos").elements.length) {
            var titulos = this.model.attributes.titulos;



            for (var m in titulos) {


                var tr = document.createElement('tr');
                tr.innerHTML = TitulosTpl({
                    attributes: titulos[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                ////  document.getElementById("titulosList").appendChild(tr);
                tr.className = "valueList";
                var table = document.getElementById("titulosList").getElementsByTagName('tbody')[0];
                table.appendChild(tr);


            }
        }


        /////mascaras...xxx 
        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });

        $('.tab-content .money').mask("#.##0,00", { reverse: true });
        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
        $('.tab-content .integer').mask("#.##0", { reverse: true });
        $('.tab-content .number').mask("##0", { reverse: true });



        this.formData = {};
        this.formData = this.iterateForm(document.forms["goods"]);
        this.formData["descriptivos"] = this.iterateForm(document.forms["descriptivos"]);
        this.formData["acuerdos"] = this.iterateMasters("acuerdos");


        this.formData["incidencias"] = this.iterateForm(document.forms["incidencias"]);

        this.formData["catastrales"] = this.iterateMasters("catastrales");
        this.formData["economicos"] = this.iterateForm(document.forms["economicos"]);
        this.formData["gps"] = this.iterateForm(document.forms["gps"]);
        this.formData["juridicos"] = this.iterateForm(document.forms["juridicos"]);
        this.formData["registrales"] = this.iterateMasters("registrales");
        this.formData["seguros"] = this.iterateForm(document.forms["seguros"]);
        this.formData["titulos"] = this.iterateMasters("titulos");
        this.formData["urbanisticos"] = this.iterateForm(document.forms["urbanisticos"]);
        this.formData["mejoras"] = this.iterateMasters("mejoras");
        this.formData["documentos"] = this.iterateDocuments(document.forms["documentos"]);


        if ($("#snapShot").attr("src"))
            this.formData.descriptivos.descriptivos_url = $("#snapShot").attr("src");



        this.formData.instanceId = S.instanceId;


        S.mApp.trigger("end:pdf", this.formData);
    },
    checkBaja: function(ev) {
        if ($(ev.target).prop("checked")) {
            $("#fechaBaja").prop("disabled", false);
            $("#motivoBaja").prop("disabled", false);
        } else {
            $("#fechaBaja").prop("disabled", true);
            $("#motivoBaja").prop("disabled", true)
        }
    },

    iterateMasters: function(section) {

        var formData = [];
        ////$("#" + section + "List tr:not(tr:first-child)").each(function() {
        $("#" + section + "List tr.valueList").each(function() {

            var line = {};
            $(this).find("input").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });
            $(this).find("textarea").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });
            $(this).find("select").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });

            if ($(this).find("#mejoras_encurso").val() === "on") {

                line["mejoras_encurso"] = $(this).find("#mejoras_encurso").is(':checked') ?
                    "1" :
                    "0";

            }

            formData.push(line);
        });

        return formData;
    },
    iterateDocuments: function() {
        var formData = [];
        ////  $(".documentosItem").each(function() {
        $(".documentosItem").each(function() {
            var line = {};
            $(this).find("input").each(function() {
                if ($(this).attr("type") === "file")
                    return;

                line[$(this).attr("id")] = $(this).val();
            });

            $(this).find("textarea").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });

            formData.push(line);
        });

        return formData;
    },
    iterateForm: function(form) {
        var formData = {};

        for (var i = 0; i < form.elements.length; i++) {
            var element = form.elements[i];
            if (element.nodeName === "BUTTON" || $(element).attr("type") === "file")
                continue;

            //If checkbox, tranform to boolean
            if ($(element).val() === "on") {
                formData[$(element).attr("id")] = $(element).is(':checked') ? "Sí" : "No";
                continue;
            }

            if (element.nodeName === "SELECT") {
                formData[$(element).attr("id")] = $(element).find("option:selected").text();
                continue;
            }

            formData[$(element).attr("id")] = $(element).val();
        }

        var filled = false;

        for (var e in formData)
            if (formData[e] !== "")
                filled = true;

        if (filled)
            return formData;
        else
            return [];
    },
    /*
    recalculateCuentas: function(ev) {
        var cuentas = parametersModel.attributes.amortizaciones;
        var cuenta = cuentas[0];
        for (var i in cuentas) {
            if ($(ev.target).val() === cuentas[i].item) {
                cuenta = cuentas[i];
            }
        }
        //If we're on the economicos page
        if ($(ev.target).attr("id") === "economicos_cuenta") {
            $("#economicos_vidaUtil").val(cuenta.vida_util);
            $("#economicos_amortizacion").val(cuenta.amortizacion);
        } else {
            //we're on the mejoras page
            $(ev.target).parents(".mejorasItem").find("#mejoras_vida").val(cuenta.vida_util);
            $(ev.target).parents(".mejorasItem").find("#mejoras_amortizacion").val(cuenta.amortizacion);
        }

        this.calculateAmortizacion();
    },

    calculateAmortizacion: function() {
        // Mejoras
        var vncMejorasTotal = 0;
        var amortAcumuladaMejorasTotal = 0;
        var valorMejoras = 0;

        var self = this;
        $("#mejorasList tr:not(tr:first-child)").each(function() {
            var mejoraData = {
                fechaAdquisicion: $(this).find("#mejoras_fecha").val(),
                vidautil_codigo: Number($(this).find("#mejoras_vida").val()),
                valoradquisicion: Number($(this).find("#mejoras_importe").val()) || 0
            };
            var amortAcumulada = Amortizacion.getAmortAcumulada(mejoraData);
            var vnc = Math.max(0, mejoraData.valoradquisicion - amortAcumulada);
            valorMejoras += mejoraData.valoradquisicion;
            vncMejorasTotal += vnc;
            amortAcumuladaMejorasTotal += amortAcumulada;
            $(this).find("#mejoras_vnc").val(self.round(vnc));
        });

        //Valores economicos
        var economicData = {
            fechaAdquisicion: $("#juridicos_fechaAdquisicion").val(),
            vidautil_codigo: Number($("#economicos_vidaUtil").val()),
            valoradquisicion: Number($("#juridicos_costeAdquisicion").val()) || this.model.attributes.juridicos_costeAdquisicion || 0
        };

        var amortAcumulada = Amortizacion.getAmortAcumulada(economicData);
        var vnc = Math.max(economicData.valoradquisicion - amortAcumulada);
        $("#economicos_valorMejoras").val(this.round(valorMejoras));
        $("#economicos_vncBien").val(this.round(vnc));
        $("#economicos_amorAcumBien").val(this.round(amortAcumulada));
        $("#economicos_vncMejoras").val(this.round(vncMejorasTotal));
        $("#economicos_amorAcumMejoras").val(this.round(amortAcumuladaMejorasTotal));
        $("#economicos_amorAcumTotal").val(this.round(amortAcumulada + amortAcumuladaMejorasTotal));
        $("#economicos_vncTotal").val(this.round(vnc + vncMejorasTotal));
    }, */
    round: function(num) {
        return Math.round(num * 100) / 100;
    },
    regions: {
        "descriptivos": "#descriptivos",

        "incidencias": "#incidencias",
        "economicos": "#economicos",
        "gps": "#gps",
        "juridicos": "#juridicos",
        "seguros": "#seguros",
        "urbanisticos": "#urbanisticos",
        "titulos": "#titulos",
        "acuerdos": "#acuerdos",
        "registrales": "#registrales",
        "catastrales": "#catastrales",
        "mejoras": "#mejoras",
        "documentos": "#documentos"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/goodsPDF/goodsPDFView.js
// module id = 184
// module chunks = 0